import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Ban, LifeBuoy, LogOut } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { formatDate } from "@/lib/utils_gg";

export default function Suspended() {
  const { user, t, lang, logout, checkingAuth } = useApp();
  const nav = useNavigate();
  if (checkingAuth) return null;
  if (!user?.suspended) return <Navigate to="/" replace />;
  return (
    <div className="max-w-2xl mx-auto px-4 md:px-6 py-10 md:py-16" data-testid="suspended-page">
      <div className="eyebrow text-primary">Soul Radar</div>
      <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tighter mt-2 flex items-center gap-3"><Ban className="w-8 h-8 text-primary" />{t("suspendedTitle")}</h1>
      <p className="mt-4 text-base" data-testid="suspended-lead">{t("suspendedLead")}</p>
      <div className="mt-6 border border-foreground p-4 md:p-5" data-testid="suspended-details">
        <div className="eyebrow text-muted-foreground">{t("suspendedReason")}</div>
        <p className="mt-1 text-base" data-testid="suspended-reason">{user.suspended_reason || t("suspendedNoReason")}</p>
        {user.suspended_at && <p className="mt-3 text-xs text-muted-foreground" data-testid="suspended-since">{t("suspendedSince", { date: formatDate(user.suspended_at.slice(0, 10), lang) })}</p>}
      </div>
      <p className="mt-6 text-sm text-muted-foreground">{t("suspendedHelp")}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to="/help?category=account" className="gg-btn-primary" data-testid="suspended-support-link"><LifeBuoy className="w-4 h-4" />{t("contactSupport")}</Link>
        <button onClick={async () => { await logout(); nav("/"); }} className="gg-btn" data-testid="suspended-logout"><LogOut className="w-4 h-4" />{t("logout")}</button>
      </div>
    </div>
  );
}
